export const REVIEWS_ENDPOINTS = {
  PENDING_REVIEWS: '/customer/pending-reviews/',
  SUBMIT_REVIEW: '/customer/reviews/',
} as const
